import { attach, createEvent, createStore, sample } from 'effector'
import { DataEventType, model as sse } from '~/core/sse'
import { model as session } from '~/entities/session'
import { portalRedirectModel as portal } from '~/features/portal/redirect'
import { model as signin } from '~/features/subscriber/sign-in'
import { T } from '~/shared/helpers'

// *
// * events
// *

export const init = createEvent()

export const signOut = createEvent()
export const tryAgain = createEvent()
export const openSubscribersPortal = createEvent()

export const $portalUrl = portal.$subscriberAccountSettingsURL
export const $pendingTryAgain = session.getAccountFx.pending
export const $pendingSignOut = createStore(false).on(signOut, T).reset(init)

const getAccessTokenBeforePortalRedirectFx = attach({
  effect: portal.getPortalAccountAccessTokenFx,
})

sample({
  clock: signOut,
  target: signin.signOut,
})

sample({
  clock: tryAgain,
  fn: () => ({ refresh: true }),
  target: session.getAccountFx,
})

sample({
  clock: openSubscribersPortal,
  target: getAccessTokenBeforePortalRedirectFx,
})

sample({
  clock: getAccessTokenBeforePortalRedirectFx.finally,
  target: portal.navigateToAccountSettings,
})

sample({
  clock: sse.dataMessage,
  filter: (data) => data.type === DataEventType.subscriptionPurchase,
  fn: () => ({ refresh: true }),
  target: session.getAccountFx,
})
